import { Link } from 'react-router-dom';
import { brand } from '@/config/brand';

const ENTRIES: Array<{ date: string; title: string; body: string }> = [
  {
    date: '2026-10-21',
    title: 'Guides, foundation pages, and AdSense content layer',
    body:
      'Launched a Guides hub with ten original explainers; expanded About, Methodology, Privacy, and Terms; added category landing intros, written featured compares, drink-detail category insights, and a public changelog. Catalog JSON cache headers no longer use year-long immutable caching.',
  },
  {
    date: '2026-10-06',
    title: 'Garage Beer Classic and Lime',
    body:
      'Added Garage Beer Classic and Lime (4% ABV, 95 cal, 3g carbs per 12 oz) with illustrative multipack offers sourced from the producer site and retail listings.',
  },
  {
    date: '2026-10-05',
    title: 'Compare UX and metric clarity',
    body:
      'Searchable drink combobox, package quantity labels, servings stepper improvements, and removal of the scale-dependent combined alcohol/cal/$ score in favor of separate ratios.',
  },
];

export function ChangelogPage() {
  return (
    <article className="panel prose-page">
      <h1>What’s new</h1>
      <p>
        Dated curation notes for {brand.name}. This log shows ongoing maintenance
        of the catalog and explainers — useful context for readers and for site
        review. It is not a full engineering changelog.
      </p>
      <ol className="changelog-list">
        {ENTRIES.map((e) => (
          <li key={e.date + e.title}>
            <h2>
              <time dateTime={e.date}>{e.date}</time> — {e.title}
            </h2>
            <p>{e.body}</p>
          </li>
        ))}
      </ol>
      <p>
        <Link to="/guides/">Guides</Link>
        {' · '}
        <Link to="/feedback/">Request a drink or fix</Link>
        {' · '}
        <Link to="/about/">About</Link>
      </p>
      <h2>Search Console note (operators)</h2>
      <p className="muted">
        After deploy, submit <code>https://boozeratio.com/sitemap.xml</code> in
        Google Search Console, confirm <code>/guides/</code> URLs are discovered,
        and wait 2–4 weeks of stable content before requesting an AdSense policy
        review for low-value content. Do not resubmit until guides and foundation
        pages are live and indexed.
      </p>
    </article>
  );
}
